import React, {useState, useEffect, useRef} from 'react';
import {Modal} from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";
import {getStoreName} from "../../Components/Utils/getStoreName";
import {getGeneratedRoute, RouteEnumFinal} from "../../Config/RouteEnum";
import ToolBar from "../../Components/Elements/ToolBar";
import {persianToEnglish} from "../../Components/Utils/utilities";
import Agent from "../../Network/Agent";
import ButtonPrimary from "../../Components/Elements/ButtonPrimary";

const AddOrEdit2 = () => {
    const storeUsername = getStoreName();
    const params = useParams()
    const productCode = params.arg;
    const isForEdit = window.location.pathname !== getGeneratedRoute(RouteEnumFinal.PRODUCT_ADD_URL_GENERATE);

    const [product, setProduct] = useState({
        code: "",
        title: "",
        description: "",
        price: "",
    });
    const [numberFormat, setNumberFormat] = useState({price: ""});
    const [selectedCats, setSelectedCats] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState({editSubmit: false, category: false});
    const [modal, setModal] = useState({category: false});
    const [errors, setErrors] = useState({category: null});

    const navigate = useNavigate()

    const textareaRef = useRef(null);

    const toggleModal = (target) => {
        setModal((prevModal) => ({
            ...prevModal,
            [target]: !prevModal[target],
        }));
    };

    const onInputTextChange = (type) => (e) => {
        const {value} = e.target;
        setProduct((prevProduct) => ({
            ...prevProduct,
            [type]: value,
        }));
    };

    const onInputPriceChange = (e) => {
        let value = e.target.value;
        value = value.replace(/[\u066B]/g, '').replace(/,/g, '');
        value = persianToEnglish(value);
        let intValue = Number(value);
        let numberFormatValue = intValue.toLocaleString("en-US");
        setNumberFormat({price: numberFormatValue});
    };

    const onCheckboxChange = (code) => () => {
        setSelectedCats((prevSelectedCats) => {
            if (prevSelectedCats.includes(code)) {
                return prevSelectedCats.filter(item => item !== code);
            } else {
                return [...prevSelectedCats, code];
            }
        });
    };

    const autoResize = (e) => {
        const textarea = e.target;
        textarea.style.height = '49.5px';
        textarea.style.height = `${textarea.scrollHeight}px`;
    };

    const onProductSubmit = (e) => {
        e.preventDefault();
        setIsLoading((prevState) => ({...prevState, editSubmit: true}));

        const data = {
            category: selectedCats,
            title: product.title,
            description: product.description,
            price: Number(numberFormat.price.replaceAll(',', '')),
        };

        if (isForEdit) {
            Agent.Product.edit(product.code, data)
                .then(response => {
                    setIsLoading((prevState) => ({...prevState, editSubmit: false}));
                    if (!response.data.error) {
                        window.location = getGeneratedRoute(RouteEnumFinal.PRODUCT_GALLERY_URL_GENERATE, productCode);
                    }
                })
                .catch(error => {
                    console.error(error.response);
                    setIsLoading((prevState) => ({...prevState, editSubmit: false}));
                });
        } else {
            Agent.Product.create(storeUsername, data)
                .then(response => {
                    const newProduct = response.data.result.product;
                    setIsLoading((prevState) => ({...prevState, editSubmit: false}));
                    if (!response.data.error) {
                        window.location = getGeneratedRoute(RouteEnumFinal.PRODUCT_GALLERY_URL_GENERATE, newProduct.code);
                    }
                })
                .catch(error => {
                    console.error(error.response);
                    setIsLoading((prevState) => ({...prevState, editSubmit: false}));
                });
        }
    };

    const submitCreateCategory = (e) => {
        e.preventDefault();
        const title = document.getElementById('input_category_title').value;
        setIsLoading({category: true});

        Agent.Category.create(storeUsername, title)
            .then(response => {
                setModal({category: false});
                setErrors({category: null});
                setIsLoading({category: false});

                Agent.Category.getList(storeUsername)
                    .then(response => {
                        setCategories(response.data.result.categories);
                    })
                    .catch(error => {
                        console.error(error.response);
                    });
            })
            .catch(error => {
                setIsLoading({category: false});
                setErrors({category: error.response.data.message});
            });
    };

    const getCategoryList = async () => {
        try {
            const response = await Agent.Category.getList(storeUsername);
            setCategories(response.data.result.categories);
        } catch (error) {
            console.error(error.response);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await getCategoryList();

            if (isForEdit) {
                try {
                    const response = await Agent.Product.getProductEdit(productCode);
                    const productData = response.data.result.product;
                    const productCategories = productData.category.map(cat => cat.code);
                    setProduct({
                        code: productData.code,
                        title: productData.title,
                        description: productData.description,
                        price: productData.price,
                    });
                    setNumberFormat({price: productData.price.toLocaleString()});
                    setSelectedCats(productCategories);
                } catch (error) {
                    console.error(error.response);
                }
            }
        };

        fetchData();
    }, [isForEdit, productCode]);
    useEffect(() => {
        if (textareaRef.current) {
            autoResize({target: textareaRef.current});
        }
    }, [product]);

    return (
        <>
            <ToolBar
                title={!isForEdit ? "افزودن محصول" : "ویرایش محصول"}
                navigate={() => navigate(-1)}
            />

            <div className='container'>
                <form onSubmit={onProductSubmit} noValidate={true}>
                    <div className={'row'}>
                        <div className={'col-12'}>
                            <div className={'form-group-input-primary mt-16'}>
                                <label className={'form-group-label'}>
                                    <div className='mobile-subtitle-strong cl-black'>
                                        عنوان محصول :
                                    </div>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name='product_title'
                                        id='input_title'
                                        onChange={onInputTextChange('title')}
                                        value={product.title}
                                        className={'form-group-input mt-10'}
                                        placeholder='مثال : کفش نایک ایرمکس'
                                    />
                                </label>
                            </div>
                        </div>

                        <div className={'col-12'}>
                            <div className={'form-group-input-primary mt-16'}>
                                <label className={'form-group-label'}>
                                    <div className='mobile-subtitle-strong cl-black'>
                                        قیمت(تومان) :
                                    </div>
                                    <input
                                        type="text"
                                        dir="ltr"
                                        autoComplete="off"
                                        name='product_price'
                                        id='input_price'
                                        pattern="\d*"
                                        inputMode="numeric"
                                        onChange={onInputPriceChange}
                                        value={numberFormat.price}
                                        className={'form-group-input mt-10'}
                                        placeholder='مثال : 220,000'
                                    />
                                </label>
                            </div>
                        </div>

                        <div className={'col-12'}>
                            <div className={'form-group-input-primary mt-16'}>
                                <label className={'form-group-label'}>
                                    <div className='mobile-subtitle-strong cl-black'>
                                        توضیحات :
                                    </div>
                                    <textarea
                                        autoComplete="off"
                                        name='product_description'
                                        id='input_description'
                                        onChange={onInputTextChange('description')}
                                        value={product.description}
                                        className={'form-group-input mt-10'}
                                        placeholder='توضیحاتی درباره محصول خود بنویسید'
                                        rows={1}
                                        style={{overflow: 'hidden', resize: 'none', minHeight: '49.5px'}}
                                        onInput={autoResize}
                                        ref={textareaRef}
                                    />
                                </label>
                            </div>
                        </div>

                        <div className={'col-12'}>
                            <div className={'d-flex align-items-center justify-content-between mt-38'}>
                                <div className={'mobile-subtitle-strong cl-black'}>دسته بندی</div>
                                <div className={'mobile-button-small cl-blue'} onClick={() => toggleModal("category")}>
                                    اضافه کردن
                                </div>
                            </div>
                            <div className={'mobile-subtitle-regular cl-black mt-8'}>
                                دسته بندی های مربوط به این محصول را انتخاب کنید
                            </div>

                            <div className={'row g-2 mt-10'}>
                                {categories.map(category => (
                                    <div key={category.code} className={'col-4'}>
                                        <div
                                            className={`form-group-checkbox-button ${selectedCats.includes(category.code) ? 'selected-category' : ''}`}
                                            style={{
                                                backgroundColor: selectedCats.includes(category.code) ? '#E0F7FA' : 'transparent',
                                                borderColor: selectedCats.includes(category.code) ? '#00796B' : '#CCCCCC'
                                            }}
                                        >
                                            <label className="form-group-label">
                                                <input
                                                    className={'form-group-input'}
                                                    type="checkbox"
                                                    onChange={onCheckboxChange(category.code)}
                                                    checked={selectedCats.includes(category.code)}
                                                    value={category.code}
                                                    name='product_category'
                                                />
                                                <div className={'label-view'}>
                                                    <div
                                                        className={'mobile-body-1-strong text-center'}>{category.title}</div>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>

                    <div className={'mt-40 mb-40'}>
                        <ButtonPrimary text='ثبت و ادامه' mode='dark-mode' isLoading={isLoading.editSubmit}/>
                    </div>
                </form>
            </div>

            {/* Modal for creating new category */}
            {modal.category && (
                <Modal className='bottom-sheet fade in' show={true} onHide={() => toggleModal('category')}>
                    <Modal.Body>
                        <div className='d-flex justify-content-center pt-10 pb-10'
                             onClick={() => toggleModal('category')}>
                            <div className='bottom-sheet-close-line btn p-0 '/>
                        </div>

                        <div className='mobile-h5 cl-black mt-20'>ایجاد دسته بندی جدید</div>
                        <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                            برای ساختن دسته بندی جدید لطفا یک عنوان برای آن وارد کنید :
                        </div>

                        <form onSubmit={submitCreateCategory}>
                            <div className='form-group-input-primary mt-32'>
                                <label className="form-group-label">
                                    <input
                                        id='input_category_title'
                                        type="text"
                                        autoComplete="off"
                                        className={`form-group-input ${errors.category === null ? "" : "hasError"}`}
                                        placeholder='عنوان دسته بندی : لباس مردانه'
                                    />
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {errors.category || ''}
                                    </div>
                                </label>
                            </div>
                            <div className='mt-32'>
                                <ButtonPrimary text='ثبت' mode='dark-mode' isLoading={isLoading.category}/>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

// Check if we're on digigold domain
const isInGoldDomain = window.location.hostname.includes('digigold.pro');

const AddOrEdit = () => {
    const storeUsername = getStoreName();
    const params = useParams()
    const productCode = params.arg;
    const isForEdit = window.location.pathname !== getGeneratedRoute(RouteEnumFinal.PRODUCT_ADD_URL_GENERATE);

    const [useGoldView, setUseGoldView] = useState(isInGoldDomain ? "GOLD" : "GENERAL")
    const [product, setProduct] = useState({
        code: "",
        title: "",
        description: "",
        price: "",
        // Gold-specific fields - Initialize with empty strings, not undefined
        weight: "",
        fee: "",
        goldKarat: "18", // Default value instead of empty
        workmanship: "",
        stoneWeight: "",
        stonePrice: "",
    });

    const [numberFormat, setNumberFormat] = useState({
        price: "",
        stonePrice: "",
        workmanship: "", // Add missing field
    });

    const [selectedCats, setSelectedCats] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState({editSubmit: false, category: false});
    const [modal, setModal] = useState({category: false});
    const [errors, setErrors] = useState({category: null});

    const navigate = useNavigate()
    const textareaRef = useRef(null);

    // Gold karat options
    const goldKaratOptions = [
        {value: "18", label: "18 عیار"},
        {value: "24", label: "24 عیار"},
    ];

    const toggleModal = (target) => {
        setModal((prevModal) => ({
            ...prevModal,
            [target]: !prevModal[target],
        }));
    };

    const onInputTextChange = (type) => (e) => {
        const {value} = e.target;
        setProduct((prevProduct) => ({
            ...prevProduct,
            [type]: value || "", // Ensure never undefined
        }));
    };

    const onInputNumberChange = (type) => (e) => {
        let value = e.target.value || ""; // Handle undefined/null
        value = value.replace(/[\u066B]/g, '').replace(/,/g, '');
        value = persianToEnglish(value);

        if (type === 'weight' || type === 'stoneWeight') {
            value = value.replace(/[^\d.]/g, '');
            const parts = value.split('.');
            if (parts.length > 2) {
                value = parts[0] + '.' + parts.slice(1).join('');
            }
            // Store raw value for weight fields
            setProduct(prev => ({...prev, [type]: value}));
            // No formatting needed for display
            setNumberFormat(prev => ({...prev, [type]: value}));
        } else {
            // For price fields, format with commas
            const numValue = Number(value) || 0;
            const formattedValue = numValue.toLocaleString("en-US");
            setNumberFormat(prev => ({...prev, [type]: formattedValue}));
            setProduct(prev => ({...prev, [type]: numValue.toString()}));
        }
    };

    const onInputPriceChange = (e) => {
        let value = e.target.value || ""; // Handle undefined/null
        value = value.replace(/[\u066B]/g, '').replace(/,/g, '');
        value = persianToEnglish(value);
        const intValue = Number(value) || 0;
        const numberFormatValue = intValue.toLocaleString("en-US");
        setNumberFormat(prev => ({...prev, price: numberFormatValue}));
        setProduct(prev => ({...prev, price: intValue.toString()}));
    };

    const onCheckboxChange = (code) => () => {
        setSelectedCats((prevSelectedCats) => {
            if (prevSelectedCats.includes(code)) {
                return prevSelectedCats.filter(item => item !== code);
            } else {
                return [...prevSelectedCats, code];
            }
        });
    };

    const autoResize = (e) => {
        const textarea = e.target;
        textarea.style.height = '49.5px';
        textarea.style.height = `${textarea.scrollHeight}px`;
    };

    const onProductSubmit = (e) => {
        e.preventDefault();
        setIsLoading((prevState) => ({...prevState, editSubmit: true}));

        const baseData = {
            category: selectedCats,
            title: product.title,
            description: product.description,
        };

        // Add different data based on domain
        const data = useGoldView === "GOLD" ? {
            ...baseData,
            weight: Number(product.weight || 0),
            metadata : {
                fee: Number(product.fee || 0),
                goldKarat: product.goldKarat,
                workmanship: Number((numberFormat.workmanship || "").replace(/,/g, '') || 0),
                stoneWeight: Number(product.stoneWeight || 0),
                stonePrice: Number((numberFormat.stonePrice || "").replace(/,/g, '') || 0),
            },
        } : {
            ...baseData,
            price: Number((numberFormat.price || "").replace(/,/g, '') || 0),
        };

        if (isForEdit) {
            Agent.Product.edit(product.code, data)
                .then(response => {
                    setIsLoading((prevState) => ({...prevState, editSubmit: false}));
                    if (!response.data.error) {
                        window.location = getGeneratedRoute(RouteEnumFinal.PRODUCT_GALLERY_URL_GENERATE, productCode);
                    }
                })
                .catch(error => {
                    console.error(error.response);
                    setIsLoading((prevState) => ({...prevState, editSubmit: false}));
                });
        } else {
            Agent.Product.create(storeUsername, data)
                .then(response => {
                    const newProduct = response.data.result.product;
                    setIsLoading((prevState) => ({...prevState, editSubmit: false}));
                    if (!response.data.error) {
                        window.location = getGeneratedRoute(RouteEnumFinal.PRODUCT_GALLERY_URL_GENERATE, newProduct.code);
                    }
                })
                .catch(error => {
                    console.error(error.response);
                    setIsLoading((prevState) => ({...prevState, editSubmit: false}));
                });
        }
    };

    const submitCreateCategory = (e) => {
        e.preventDefault();
        const title = document.getElementById('input_category_title').value;
        setIsLoading({category: true});

        Agent.Category.create(storeUsername, title)
            .then(response => {
                setModal({category: false});
                setErrors({category: null});
                setIsLoading({category: false});

                Agent.Category.getList(storeUsername)
                    .then(response => {
                        setCategories(response.data.result.categories);
                    })
                    .catch(error => {
                        console.error(error.response);
                    });
            })
            .catch(error => {
                setIsLoading({category: false});
                setErrors({category: error.response.data.message});
            });
    };

    const getCategoryList = async () => {
        try {
            const response = await Agent.Category.getList(storeUsername);
            setCategories(response.data.result.categories);
        } catch (error) {
            console.error(error.response);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await getCategoryList();

            if (isForEdit) {
                try {
                    const response = await Agent.Product.getProductEdit(productCode);
                    const productData = response.data.result.product;
                    const productCategories = productData.category.map(cat => cat.code);
                    console.log(productData)

                    setProduct({
                        code: productData.code || "",
                        title: productData.title || "",
                        description: productData.description || "",
                        price: productData.price?.toString() || "",
                        // Gold fields - ensure all are strings, never undefined
                        weight: productData.weight?.toString() || "",
                        fee: productData?.metadata?.fee?.toString() || "",
                        goldKarat: productData?.metadata?.goldKarat || "18",
                        workmanship: productData?.metadata?.workmanship?.toString() || "",
                        stoneWeight: productData?.metadata?.stoneWeight?.toString() || "",
                        stonePrice: productData?.metadata?.stonePrice?.toString() || "",
                    });

                    // Set number formats - ensure all values are strings
                    const formats = {
                        price: "",
                        stonePrice: "",
                        workmanship: "",
                    };

                    if (useGoldView === "GOLD") {
                        formats.stonePrice = productData.metadata?.stonePrice?.toLocaleString() || "";
                        formats.workmanship = productData.metadata?.workmanship?.toLocaleString() || "";
                    } else if (useGoldView === "GENERAL") {
                        formats.price = productData.price?.toLocaleString() || "";
                    }

                    setNumberFormat(formats);
                    setSelectedCats(productCategories);
                } catch (error) {
                    console.error(error.response);
                }
            }
        };

        fetchData();
    }, [isForEdit, productCode, useGoldView]);

    useEffect(() => {
        if (textareaRef.current) {
            autoResize({target: textareaRef.current});
        }
    }, [product]);

    const renderPricingFields = () => {
        if (useGoldView === "GOLD") {
            return (
                <>
                    {/* Weight Field */}
                    <div className={'col-12'}>
                        <div className={'form-group-input-primary mt-16'}>
                            <label className={'form-group-label'}>
                                <div className='mobile-subtitle-strong cl-black'>
                                    وزن طلا (گرم) :
                                </div>
                                <input
                                    type="text"
                                    dir="ltr"
                                    autoComplete="off"
                                    name='product_weight'
                                    id='input_weight'
                                    inputMode="decimal"
                                    onChange={onInputNumberChange('weight')}
                                    value={product.weight || ""} // Ensure never undefined
                                    className={'form-group-input mt-10'}
                                    placeholder='مثال : 5.75'
                                />
                            </label>
                        </div>
                    </div>

                    {/* Gold Karat Selection */}
                    <div className='col-12'>
                        <div className='form-group-select-option mt-16'>
                            <label className='form-group-label w-100'>
                                <div className='mobile-subtitle-strong cl-black'>
                                    عیار طلا :
                                </div>
                                <select
                                    name='product_karat'
                                    id='input_karat'
                                    onChange={onInputTextChange('goldKarat')}
                                    value={product.goldKarat || "18"} // Always have a default
                                    className='form-group-select bg-gray-F5F5F5 mt-10'
                                >
                                    {goldKaratOptions.map(option => (
                                        <option className="form-group-option" key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </div>
                    </div>

                    {/* Fee Percentage */}
                    <div className={'col-12'}>
                        <div className={'form-group-input-primary mt-16'}>
                            <label className={'form-group-label'}>
                                <div className='mobile-subtitle-strong cl-black'>
                                    درصد کارمزد :
                                </div>
                                <input
                                    type="text"
                                    dir="ltr"
                                    autoComplete="off"
                                    name='product_fee'
                                    id='input_fee'
                                    pattern="\d*"
                                    inputMode="numeric"
                                    onChange={onInputTextChange('fee')}
                                    value={product.fee || ""} // Ensure never undefined
                                    className={'form-group-input mt-10'}
                                    placeholder='مثال : 15'
                                />
                            </label>
                        </div>
                    </div>

                    {/* Workmanship Fee */}
                    <div className={'col-12'}>
                        <div className={'form-group-input-primary mt-16'}>
                            <label className={'form-group-label'}>
                                <div className='mobile-subtitle-strong cl-black'>
                                    اجرت ساخت (تومان) :
                                </div>
                                <input
                                    type="text"
                                    dir="ltr"
                                    autoComplete="off"
                                    name='product_workmanship'
                                    id='input_workmanship'
                                    pattern="\d*"
                                    inputMode="numeric"
                                    onChange={onInputNumberChange('workmanship')}
                                    value={numberFormat.workmanship || ""} // Ensure never undefined
                                    className={'form-group-input mt-10'}
                                    placeholder='مثال : 500,000'
                                />
                            </label>
                        </div>
                    </div>

                    {/* Stone Weight */}
                    <div className={'col-12'}>
                        <div className={'form-group-input-primary mt-16'}>
                            <label className={'form-group-label'}>
                                <div className='mobile-subtitle-strong cl-black'>
                                    وزن نگین (گرم) :
                                </div>
                                <input
                                    type="text"
                                    dir="ltr"
                                    autoComplete="off"
                                    name='product_stone_weight'
                                    id='input_stone_weight'
                                    inputMode="decimal"
                                    onChange={onInputNumberChange('stoneWeight')}
                                    value={product.stoneWeight || ""} // Ensure never undefined
                                    className={'form-group-input mt-10'}
                                    placeholder='مثال : 0.25'
                                />
                            </label>
                        </div>
                    </div>

                    {/* Stone Price */}
                    <div className={'col-12'}>
                        <div className={'form-group-input-primary mt-16'}>
                            <label className={'form-group-label'}>
                                <div className='mobile-subtitle-strong cl-black'>
                                    قیمت نگین (تومان) :
                                </div>
                                <input
                                    type="text"
                                    dir="ltr"
                                    autoComplete="off"
                                    name='product_stone_price'
                                    id='input_stone_price'
                                    pattern="\d*"
                                    inputMode="numeric"
                                    onChange={onInputNumberChange('stonePrice')}
                                    value={numberFormat.stonePrice || ""} // Ensure never undefined
                                    className={'form-group-input mt-10'}
                                    placeholder='مثال : 2,000,000'
                                />
                            </label>
                        </div>
                    </div>
                </>
            );
        } else {
            return (
                <div className={'col-12'}>
                    <div className={'form-group-input-primary mt-16'}>
                        <label className={'form-group-label'}>
                            <div className='mobile-subtitle-strong cl-black'>
                                قیمت(تومان) :
                            </div>
                            <input
                                type="text"
                                dir="ltr"
                                autoComplete="off"
                                name='product_price'
                                id='input_price'
                                pattern="\d*"
                                inputMode="numeric"
                                onChange={onInputPriceChange}
                                value={numberFormat.price || ""} // Ensure never undefined
                                className={'form-group-input mt-10'}
                                placeholder='مثال : 220,000'
                            />
                        </label>
                    </div>
                </div>
            );
        }
    };

    return (
        <>
            <ToolBar
                title={!isForEdit ?
                    ("افزودن محصول") :
                    ("ویرایش محصول")
                }
                navigate={() => navigate(-1)}
            />

            <div className='container'>
                <form onSubmit={onProductSubmit} noValidate={true}>
                    <div className={'row'}>
                        <div className={'col-12'}>
                            <div className={'form-group-input-primary mt-16'}>
                                <label className={'form-group-label'}>
                                    <div className='mobile-subtitle-strong cl-black'>
                                        عنوان محصول :
                                    </div>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name='product_title'
                                        id='input_title'
                                        onChange={onInputTextChange('title')}
                                        value={product.title || ""} // Ensure never undefined
                                        className={'form-group-input mt-10'}
                                        placeholder={useGoldView === "GOLD" ? 'مثال : گردنبند طلا کارتیه' : 'مثال : کفش نایک ایرمکس'}
                                    />
                                </label>
                            </div>
                        </div>

                        {renderPricingFields()}

                        <div className={'col-12'}>
                            <div className={'form-group-input-primary mt-16'}>
                                <label className={'form-group-label'}>
                                    <div className='mobile-subtitle-strong cl-black'>
                                        توضیحات :
                                    </div>
                                    <textarea
                                        autoComplete="off"
                                        name='product_description'
                                        id='input_description'
                                        onChange={onInputTextChange('description')}
                                        value={product.description || ""} // Ensure never undefined
                                        className={'form-group-input mt-10'}
                                        placeholder='توضیحاتی درباره محصول خود بنویسید'
                                        rows={1}
                                        style={{overflow: 'hidden', resize: 'none', minHeight: '49.5px'}}
                                        onInput={autoResize}
                                        ref={textareaRef}
                                    />
                                </label>
                            </div>
                        </div>

                        <div className={'col-12'}>
                            <div className={'d-flex align-items-center justify-content-between mt-38'}>
                                <div className={'mobile-subtitle-strong cl-black'}>دسته بندی</div>
                                <div className={'mobile-button-small cl-blue'} onClick={() => toggleModal("category")}>
                                    اضافه کردن
                                </div>
                            </div>
                            <div className={'mobile-subtitle-regular cl-black mt-8'}>
                                دسته بندی های مربوط به این محصول را انتخاب کنید
                            </div>

                            <div className={'row g-2 mt-10'}>
                                {categories.map(category => (
                                    <div key={category.code} className={'col-4'}>
                                        <div
                                            className={`form-group-checkbox-button ${selectedCats.includes(category.code) ? 'selected-category' : ''}`}
                                            style={{
                                                backgroundColor: selectedCats.includes(category.code) ? '#E0F7FA' : 'transparent',
                                                borderColor: selectedCats.includes(category.code) ? '#00796B' : '#CCCCCC'
                                            }}
                                        >
                                            <label className="form-group-label">
                                                <input
                                                    className={'form-group-input'}
                                                    type="checkbox"
                                                    onChange={onCheckboxChange(category.code)}
                                                    checked={selectedCats.includes(category.code)}
                                                    value={category.code}
                                                    name='product_category'
                                                />
                                                <div className={'label-view'}>
                                                    <div
                                                        className={'mobile-body-1-strong text-center'}>{category.title}</div>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className={'mt-40 mb-40'}>
                        <ButtonPrimary text='ثبت و ادامه' mode='dark-mode' isLoading={isLoading.editSubmit}/>
                    </div>
                </form>
            </div>

            {/* Modal for creating new category */}
            {modal.category && (
                <Modal className='bottom-sheet fade in' show={true} onHide={() => toggleModal('category')}>
                    <Modal.Body>
                        <div className='d-flex justify-content-center pt-10 pb-10'
                             onClick={() => toggleModal('category')}>
                            <div className='bottom-sheet-close-line btn p-0 '/>
                        </div>

                        <div className='mobile-h5 cl-black mt-20'>ایجاد دسته بندی جدید</div>
                        <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                            برای ساختن دسته بندی جدید لطفا یک عنوان برای آن وارد کنید :
                        </div>

                        <form onSubmit={submitCreateCategory}>
                            <div className='form-group-input-primary mt-32'>
                                <label className="form-group-label">
                                    <input
                                        id='input_category_title'
                                        type="text"
                                        autoComplete="off"
                                        className={`form-group-input ${errors.category === null ? "" : "hasError"}`}
                                        placeholder={useGoldView === "GOLD" ?
                                            'عنوان دسته بندی : گردنبند طلا' :
                                            'عنوان دسته بندی : لباس مردانه'
                                        }
                                    />
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {errors.category || ''}
                                    </div>
                                </label>
                            </div>
                            <div className='mt-32'>
                                <ButtonPrimary text='ثبت' mode='dark-mode' isLoading={isLoading.category}/>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

export default AddOrEdit;
